module.exports = __webpack_public_path__ + "static/media/Ex1-S3.4b1a225e.PNG";